module.exports = __webpack_public_path__ + "static/media/screen-linkedin-altyor.2eeaf788.png";